import { jsxs, jsx } from 'react/jsx-runtime';
import { isPresetGradientColor } from '@flex-design-system/fx-colors';
import { forwardRef } from 'react';
import { getColor } from '../utils/color.mjs';
import useId from './hooks/useId.mjs';
import { getID, FlexLinearGradient } from './shared/FlexLinearGradient.mjs';

const DeleteIcon = forwardRef(
  ({
    color: rawColor = "currentColor",
    size: sizeFromProps,
    type = "default",
    style,
    ...props
  }, forwardedRef) => {
    const { id } = useId();
    const isGradient = isPresetGradientColor(rawColor);
    const color = isGradient ? `url(#${getID(rawColor, id)})` : getColor(rawColor);
    const size = sizeFromProps ?? 24;
    if (type === "fill") {
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: size,
          height: size,
          fill: "none",
          viewBox: "0 0 24 24",
          ...props,
          ref: forwardedRef,
          style: sizeFromProps !== void 0 ? { width: size, height: size, flexShrink: 0, ...style } : { flexShrink: 0, ...style },
          children: [
            isGradient && /* @__PURE__ */ jsx(FlexLinearGradient, { id }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "M10.536 3c-1.201 0-2.28.73-2.727 1.843l-.477 1.19H5.667C4.747 6.034 4 6.78 4 7.7c0 .676.2 1.338.576 1.9l.437.654v8.826c0 1.06.861 1.921 1.924 1.921h10.126c1.063 0 1.924-.86 1.924-1.921v-8.826l.437-.654A3.423 3.423 0 0 0 20 7.7c0-.92-.747-1.665-1.667-1.665h-1.665l-.477-1.19A2.937 2.937 0 0 0 13.464 3h-2.928Zm.35 7.079v7.887H9.063V10.08h1.823Zm4.05 0v7.887h-1.822V10.08h1.823Z",
                fillRule: "evenodd",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
    if (type === "default") {
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: size,
          height: size,
          fill: "none",
          viewBox: "0 0 24 24",
          ...props,
          ref: forwardedRef,
          style: sizeFromProps !== void 0 ? { width: size, height: size, flexShrink: 0, ...style } : { flexShrink: 0, ...style },
          children: [
            isGradient && /* @__PURE__ */ jsx(FlexLinearGradient, { id }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "M10.536 4.82c-.456 0-.865.277-1.034.7l-.206.514h5.409l-.207-.515c-.169-.422-.578-.699-1.034-.699h-2.928Zm-2.727.023-.477 1.19H5.667C4.747 6.034 4 6.78 4 7.7c0 .676.2 1.338.576 1.9l.437.654v8.826c0 1.06.861 1.921 1.924 1.921h10.126c1.063 0 1.924-.86 1.924-1.921v-8.826l.437-.654A3.423 3.423 0 0 0 20 7.7c0-.92-.747-1.665-1.667-1.665h-1.665l-.477-1.19A2.937 2.937 0 0 0 13.464 3h-2.928c-1.201 0-2.28.73-2.727 1.843ZM5.83 7.853h12.34a1.606 1.606 0 0 1-.263.737l-.742 1.112v9.377a.101.101 0 0 1-.102.1H6.937a.101.101 0 0 1-.102-.1V9.702L6.093 8.59a1.605 1.605 0 0 1-.263-.736Zm5.056 10.113V10.08H9.063v7.887h1.823Zm4.05 0V10.08h-1.822v7.887h1.823Z",
                fillRule: "evenodd",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
    console.error(
      `DeleteIcon doesn't support the combination of ${size} and ${type}`
    );
    return null;
  }
);

export { DeleteIcon };
//# sourceMappingURL=DeleteIcon.mjs.map
